import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from "react-router-dom";

import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import { getClub } from '../../routes/UserAction';
import { domain, reduceText, timeFormat } from '../../data/dummyData';

import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";

export default function Club() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);

    const search = useLocation().search;
    const id = new URLSearchParams(search).get("id");

    const [clubData, setClubData] = useState(null);
    const [selectedTask, setSelectedTask] = useState(null);
    const [solutionFile, setSolutionFile] = useState(null);

    useEffect(() => {
        dispatch(getClub(id))
            .then(response => {
                setClubData(response.payload.data);
            })
            .catch(console.error);
    }, [id]);

    const handleUploadSolution = (taskId) => {
        setSelectedTask(taskId);
        document.getElementById('uploadModal').style.display = 'block';
    };

    const closeModal = () => {
        setSelectedTask(null);
        setSolutionFile(null);
        document.getElementById('uploadModal').style.display = 'none';
    };

    const handleFileChange = (e) => {
        setSolutionFile(e.target.files[0]);
    };

    const submitSolution = () => {
        if (solutionFile) {
            console.log('Submitting file for task:', selectedTask, solutionFile);
            closeModal();
        }
    };

    const options2 = {
        loop: true,
        margin: 10,
        nav: true, // ✅ Enable navigation arrows
        dots: false, // Hide dots if not needed
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        },
        navText: [
            "<i class='bi bi-arrow-left custom-arrow text-white'></i>",
            "<i class='bi bi-arrow-right custom-arrow text-white'></i>",
        ], // ✅ Custom arrows
    };

    const options3 = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        // items: 3,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        }
    };

    return (
        <>
            <Header page={'country'} />

            {/* <!-- About Start --> */}
            <div className="container-fluid about pt-5" style={{zIndex: 1}}>
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-content h-100">
                                <h4 className="" style={{color: 'gold'}}>{clubData?.name? clubData.name: ''}</h4>
                                {/* <h1 className="display-4 text-white mb-4">{clubData?.about? clubData.about: ''}</h1> */}
                                <hr/>
                                <p className="mb-4 text-white">{clubData?.about? clubData.about: ''}</p>
                                
                                <div className="d-flex justify-content-start gap-4 mt-3 mb-4">
                                    <div className="small text-white">
                                        <span className="fa fa-users text-white me-2"></span> {clubData?.members?.length? clubData?.members?.length: 0}
                                    </div>
                                    <div className="small text-white">
                                        <span className="fa fa-calendar text-white me-2"></span> {timeFormat(clubData?.created_at)}
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="about-img h-100">
                                <div className="about-img-inner d-flex h-100">
                                    <img src={clubData?.image? domain+clubData.image: "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt={clubData?.uuid? clubData.uuid :''}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}

            {/* <!--Schools Start --> */}
            <div className="container-fluid feature">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}>{clubData?.name? clubData.name: ''} Programs</h4>
                        <h1 className="display-4 mb-4">Our Programs</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="feature-carousel owl-carousel"
                        {...options2}
                    >
                    {/* <div className="feature-carousel owl-carousel"> */}
                        {clubData?.programs? clubData.programs?.map((row) => (
                            <div key={row.id} className="feature-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="feature-img">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100"  alt=""/>
                                </div>
                                <div className="feature-content p-4">
                                    <h4 className="mb-3">{row.name? row.name: ''}</h4>
                                    <p className="mb-4">
                                        {row.about? row.about: ''}
                                    </p>
                                    {/* <Link to={row.uuid? `/country?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Register a School</span></Link> */}
                                </div>
                            </div>
                        )) : null}
                        
                    {/* </div> */}
                    </OwlCarousel>
                    <div className="feature-shaps"></div>
                </div>
            </div>
            {/* <!-- Schools End --> */}

            {/* <!-- Clubs Start --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> Activities in {clubData?.name? clubData.name: ''} </h4>
                        <h1 className="display-4 mb-4">Activities</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                    {clubData?.programs?.map((program) =>
                        program.sessions?.map((row) => (
                            <div className="blog-item wow fadeInUp" data-wow-delay="0.2s" key={row.id}>
                            <div className="blog-img p-4 pb-0">
                                <a href="#">
                                <img
                                    src={row.image ? domain + row.image : "./assets/img/soft.png"}
                                    className="img-fluid w-100"
                                    alt=""
                                />
                                </a>
                            </div>
                            <div className="blog-content p-4">
                                {/* <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4"> */}
                                <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                {/* <div className="small">
                                    <span className="fa fa-user text-primary me-2"></span> Martin.C
                                </div> */}
                                <div className="small text-primary">
                                    <span className="fa fa-calendar text-primary me-2"></span> {timeFormat(row.created_at)}
                                </div>
                                </div>
                                <Link to={row.uuid ? `/club?id=${clubData.uuid}` : '/'} className="h4 d-inline-block mb-3">
                                {row.name || ''}
                                </Link>
                                <p className="mb-3">{row.about? reduceText(row.about, 200, '...'): ''}</p>
                                <Link to={row.uuid ? `/club?id=${clubData.uuid}` : '/'} className="btn btn-dark py-2 px-4 ms-2">
                                <span className="me-2">Read More</span> <i className="fa fa-arrow-right"></i>
                                </Link>
                            </div>
                            </div>
                        ))
                    )}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Clubs End --> */}

            {/* <!-- Members Start --> */}
            <div className="container-fluid team py-5" style={{ 
                position: 'relative',
                overflow: 'hidden',
                background: "linear-gradient(rgba(255, 245, 225, 0.9), rgba(132, 199, 137, 0.9)), url('./assets/img/afro.png')",
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
            }}>
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}>{clubData?.school?.name? clubData?.school?.name: ''}</h4>
                        <h1 className="display-4 mb-4">{clubData?.name? clubData?.name: ''} Members</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>
                    <div className="row gy-5 gy-lg-4 gx-4">
                        {clubData?.members?.length? clubData.members.map((row) => (
                            <div key={row.id} className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                                <div className="team-item">
                                    <div className="team-img">
                                        <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt="Image"/>
                                        <div className="team-icon">
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                        </div>
                                    </div>
                                    <div className="team-content">
                                        <h4>{row.name? row.name: ''}</h4>
                                        <p className="mb-0">{row.status ==1? 'Active': 'Inactive'}</p>
                                    </div>
                                </div>
                            </div>
                        )) : <></>}
                        
                    </div>
                </div>
            </div>
            {/* <!-- Members End --> */}

            {/* map */}
            {/* <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
                <div className="h-100 overflow-hidden">
                    <iframe className="w-100" style={{height: '400px'}} src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.33750346623!2d-73.97968099999999!3d40.6974881!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY%2C%20USA!5e0!3m2!1sen!2sbd!4v1694259649153!5m2!1sen!2sbd" 
                    loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div> */}
            {/* Map End */}

            <Footer />
        </>
    );
}
